import { CategoryLinks } from "./components/categoryLinks/categoryLinks";
import { CategorySlide } from "./components/categorySlide/categorySlide";
import { RootCategory } from "./components/rootCategory";
import { SubCategories } from "./components/subCategories";
import { Trigger } from "./components/trigger";

export const Assortiment = Object.assign(
    {},
    {
        Trigger: Trigger,
        RootCategory: RootCategory,
        SubCategories: SubCategories,
        CategoryLinks: CategoryLinks,
        CategorySlide: CategorySlide
    }
);
